import axios from '@/plugins/axios'

/**
 * 注册用户
 * @param {Object} registerData - 注册表单数据
 * @returns {Promise}
 */
export function register(registerData) {
    return axios({
        url: '/register',
        method: 'POST',
        data: registerData,
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export function sendVerificationCode(userEmail){
    return axios({
        url: '/register/sendEmail',
        method: 'POST',
        params: {
            userEmail: userEmail
        }
    })
}